// Prominent Maeve-First card (PO Spec §1.5) — the Employee "I just need to
// talk" Companion entry. Thin wrapper over the canonical `NavCard` with the
// `prominent` treatment. Functional shape matches `ActionCard` so the two
// stay interchangeable in callers.

import type { ReactNode } from 'react';
import { NavCard } from '@/components/ui/Card.tsx';

interface ProminentActionCardProps {
  to: string;
  title: string;
  subtitle: string;
  icon: ReactNode;
}

export function ProminentActionCard({ to, title, subtitle, icon }: ProminentActionCardProps) {
  return <NavCard prominent to={to} title={title} subtitle={subtitle} icon={icon} />;
}
